// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1IFTV","productName":"Table_productName__2gy5X"};